export default __webpack_public_path__ + "static/media/Navbg.471c7bf6.png";